/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import Box from '@mui/material/Box'

import { standardSpinner, circularSpinner } from '../../helpers/spinners'
import { inProcessAllAuth, createGoogleSignInButton } from './helpers/inProcessLoginRegister'
import { navbarHeight, dashboardNavbarHeight, footerHeight, positionChangeWidthSm, oneTimeRate } from '../../helpers/variableDefaults'
import useWindowDimensions from '../../helpers/windowDimensions'
import { seoPageTags, customAnalyticsEvent, registerPageViewsInsideMetaBrowser, runGTAGScript } from '../../helpers/analytics'
import { userIsAuthenticated, getPayload } from '../../helpers/storage'
import { dummyBox, isInstagramOrFacebook } from '../../helpers/globalHelpers'
import { advisoryTypography } from '../../helpers/typographies'

// Stripe
// import { useStripe, useElements } from '@stripe/react-stripe-js'

// All Auth Component — 
// Set states here, most of the code is in the inProcessLoginRegister helper; 
// I do it this way so that login can occur in multiple places throughout code, and states must be defined in components, but having the functions in helper views makes it so they only have to be written once
const AllAuth = (props) => {

  // Destructure Props
  const { 
    fromCreateAccount, 
  } = props
  
  // Navigate
  const navigate = useNavigate()

  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // URL Path
  const urlPath = window.location.pathname

  // Email/Password Login
  const [loginForm, setLoginForm] = useState({
    email: '',
    password: '',
    loginMethod: 'emailLogin',
  })
  const [ loginErrors, setLoginErrors ] = useState(false)
  const [loadingLogin, setLoadingLogin] = useState(false)

  // Email/Password Register
  const [registerForm, setRegisterForm] = useState({
    email: '',
    password: '',
    passwordConfirmation: '',
    loginMethod: 'emailRegister',
    acceptedTOS: true,
  })
  const [ registerErrors, setRegisterErrors ] = useState({})
  const [loadingRegister, setLoadingRegister] = useState(false)
  const [acceptedTOS, setAcceptedTOS] = useState(false)

  // For toggling between Login and Register screens
  const [loginViewIndex, setLoginViewIndex] = useState(fromCreateAccount ? 1 : 0)

  // Google Login
  const [ loadingGoogle, setLoadingGoogle ] = useState(false)
  const [ googleLoginErrors, setGoogleLoginErrors ] = useState(false)

  // Facebook Login
  const [ loadingFacebook, setLoadingFacebook ] = useState(false)
  const [ facebookLoginErrors, setFacebookLoginErrors ] = useState(false)
  

  // initial useEffect
  useEffect(() => {
    if (userIsAuthenticated()) {
      const payload = getPayload()
      if (payload.sub) {
        navigate(`/dashboard/${payload.sub}`, { state: { previousLocationPathname: urlPath } })
      }
    } 

    // Used to initialize the Google Sign-In button, runs once at the end of pageload
    const renderGoogleSignInButton = async () => {
      await createGoogleSignInButton(urlPath, setGoogleLoginErrors, setFacebookLoginErrors, setLoginErrors, setRegisterErrors, setLoadingGoogle, setLoadingFacebook, setLoadingLogin, setLoadingRegister, navigate)
    }

    renderGoogleSignInButton()

    // Register pageviews inside meta browser
    const checkForMetaBrowser = () => {
      if (isInstagramOrFacebook()) {
        
        const timeout = setTimeout(() => {
          // console.log('⏱️ Delayed effect: 250ms later');
          // Put your delayed logic here
          registerPageViewsInsideMetaBrowser(fromCreateAccount ? 'Register' : 'Login')
        }, 250) // delay in milliseconds

        return () => clearTimeout(timeout)
      }
    }
    
    checkForMetaBrowser()

  }, [])

  useEffect(() => {

  }, [loadingGoogle, loadingFacebook, loadingLogin, loadingRegister])


  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {
        // !isInstagramOrFacebook() ? 
        urlPath.includes('login')
          ?
          seoPageTags(
            fromCreateAccount ? 'Register' : 'Login'
          )
          :
          <></>
        // :
        // runGTAGScript()
      }
      
      {/* Login Body */}
      <Box
        sx={{
          // mt: 4,
          // backgroundColor: 'orange',
          pb: 8,
          width: '100%',
          maxHeight: '100%', 
          // minHeight: (loadingGoogle || loadingFacebook || loadingLogin || loadingRegister) ? `calc(100vh - ${navbarHeight})` : `calc(100vh - ${navbarHeight} - ${footerHeight})`,
          minHeight: (loadingGoogle || loadingFacebook || loadingLogin || loadingRegister) ? `100vh` : `calc(100vh - ${navbarHeight} - ${footerHeight})`,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: (width < positionChangeWidthSm && !(loadingGoogle || loadingFacebook || loadingLogin || loadingRegister)) ? 'flex-start' : 'center',
          alignItems: 'center',
        }}
      >
        {/* Login or Register View */}

        {(loadingGoogle || loadingFacebook || loadingLogin || loadingRegister) ?
          <>
            {dummyBox(`${dashboardNavbarHeight}px`)}
            {/* {advisoryTypography(`Logging in...`)} */}
            {/* {standardSpinner()} */}
            {circularSpinner()}
          </>
          : 
          <>
            {inProcessAllAuth(
              urlPath, 
              loginViewIndex,
              loginForm, setLoginForm, loginErrors, setLoginErrors, loadingLogin, setLoadingLogin,
              registerForm, setRegisterForm, registerErrors, setRegisterErrors, loadingRegister, setLoadingRegister, acceptedTOS, setAcceptedTOS,
              navigate,
              googleLoginErrors, facebookLoginErrors,
              setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors,
              width
            )}
          </>
        }

      </Box>
    </>
  )
}

export default AllAuth